import { Component, Input } from '@angular/core';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { UserToDosStatistics } from 'app/projects/user/src/lib/models/user-to-dos-statistics.model';
import { TeamNavigationService } from '../../services/team-navigation.service';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';

@Component({
    selector: 'app-user-todos',
    templateUrl: './user-todos.component.html',
    styleUrls: ['./user-todos.component.scss'],
})
export class UserTodosComponent extends UnsubscribeOnDestroy {
    @Input()
    teamId: string;

    @Input()
    memberId: string;

    @Input()
    userToDoStatistics: UserToDosStatistics;

    constructor(private _store: Store, private _teamNavigationService: TeamNavigationService) {
        super();
    }

    openToDosPage(): void {
        this._teamNavigationService.addTeamPath(window.location.pathname);
        this._store.dispatch(new Navigate([`/my-teams/team/${this.teamId}/member/${this.memberId}/to-dos`]));
    }
}
